import { useState, useContext, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import AuthContext from '../../context/AuthContext';
import { checkAdminUnreadAlarm } from '../../utils/alarmService';
import { adminAlarmKeys } from '../../hooks/useAlarm';
import './css/topnav.css';
import AdminAlarmModal from './modal/AdminAlarmModal';
import ChangePwModal from './modal/ChangePwModal';
import { IoMenu, IoClose, IoNotificationsOutline, IoPerson } from "../../components/icons";

const TopNav = ({ toggleSidebar, isSidebarOpen }) => {
  const { admin, adminLogout } = useContext(AuthContext);
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const [isAlarmModalOpen, setIsAlarmModalOpen] = useState(false);
  const [isChangePwModalOpen, setIsChangePwModalOpen] = useState(false);
  const alarmBtnRef = useRef(null);

  const { data: hasAlarms = false } = useQuery({
    queryKey: ["adminUnreadAlarm"],
    queryFn: checkAdminUnreadAlarm,
    refetchInterval: 60000,
  });

  const handleAlarmRead = () => {
    queryClient.invalidateQueries({ queryKey: ["adminUnreadAlarm"] });
    queryClient.invalidateQueries({ queryKey: adminAlarmKeys.list() });
  };

  const handleLogout = async () => {
    if (window.confirm('로그아웃 하시겠습니까?')) {
      await adminLogout();
      navigate('/admin/login');
    }
  };

  return (
    <>
      <nav className="admin-sb-topnav navbar navbar-expand navbar-dark admin-topnav-custom">
        <div className="admin-topnav-left-section">
          <a className="navbar-brand admin-topnav-logo" href="/admin">
            <img src="/images/logo_v2_white.png" alt="logo" />
          </a>
          <button
            className="admin-hamburger-btn"
            onClick={toggleSidebar}
            aria-label="Toggle sidebar"
          >
            {isSidebarOpen ? <IoClose /> : <IoMenu />}{" "}
          </button>
        </div>
        <div className="ms-auto"></div>
        {/* Navbar*/}
        <ul className="navbar-nav ms-md-0 me-3 me-lg-4">
          <li className="nav-item admin-topnav-alarm-item">
            <button
              ref={alarmBtnRef}
              className="nav-link admin-topnav-alarm-btn"
              onClick={() => setIsAlarmModalOpen(!isAlarmModalOpen)}
            >
              <IoNotificationsOutline className="admin-topnav-i" />
              {hasAlarms && <span className="admin-topnav-alarm-badge"></span>}
            </button>
          {isAlarmModalOpen && <AdminAlarmModal onClose={() => setIsAlarmModalOpen(false)} onRead={handleAlarmRead} buttonRef={alarmBtnRef} />}
          </li>
          <li className="nav-item dropdown">
            <a
              className="nav-link dropdown-toggle"
              id="navbarDropdown"
              href="/"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <IoPerson className="admin-topnav-i" />
            </a>
          <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdown">
            <li className='dropdown-info'>
              <span className="dropdown-user">{admin?.empNm || '관리자'}님</span>
                &nbsp;
              <span className='dropdown-text'>환영합니다!</span>
              </li>
            <li><hr className="dropdown-divider" /></li>
              <li>
                <button
                  className="dropdown-item"
                  onClick={() => setIsChangePwModalOpen(true)}
                style={{ background: 'none', border: 'none', cursor: 'pointer', textAlign: 'left', width: '100%' }}
                >
                  비밀번호 변경
                </button>
              </li>
              <li>
                <button
                  className="dropdown-item"
                  onClick={handleLogout}
                style={{ background: 'none', border: 'none', cursor: 'pointer', textAlign: 'left', width: '100%' }}
                >
                  로그아웃
                </button>
              </li>
            </ul>
          </li>
        </ul>
      </nav>

      {isChangePwModalOpen && (
        <ChangePwModal onClose={() => setIsChangePwModalOpen(false)} />
      )}
    </>
  );
};

export default TopNav;